import { render, staticRenderFns } from "./viptop.vue?vue&type=template&id=024296dc&scoped=true&"
import script from "./viptop.vue?vue&type=script&lang=js&"
export * from "./viptop.vue?vue&type=script&lang=js&"
import style0 from "./viptop.vue?vue&type=style&index=0&id=024296dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024296dc",
  null
  
)

export default component.exports